import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';

import useEnv from '@zenbusiness/application-commons-env';
import { ExperimentsProvider } from '@zenbusiness/application-commons-experiments';

import useWindowConfig from '#client/hooks/useWindowConfig';

import ExperimentsContent from './ExperimentsContent';
import ExperimentsReadyGate from './ExperimentsReadyGate';

function ExperimentsWrapper({ children, flowConfig }) {
  const { DEPLOY_ENV, LD_CLIENT_ID } = useEnv();
  const { entityType, id } = flowConfig;
  const { formFactor } = useWindowConfig();

  // TODO: Once we resolve having to identify via the provider, this will be deleted (jh)
  //       See also: https://counsl.atlassian.net/browse/FUN-4892
  const identityProps = {
    ...(entityType ? { formationType: entityType } : {}),
    formFactor
  };

  const experimentProviderProps = {
    appId: 'shopping-ui',
    clientId: LD_CLIENT_ID,
    deployEnv: DEPLOY_ENV,
    flowId: id,
    evaluationReasons: true
  };

  return (
    <ExperimentsProvider {...experimentProviderProps} {...identityProps}>
      <ExperimentsReadyGate>
        <ExperimentsContent baseConfig={flowConfig}>
          {(activeConfig) => (children ? children(activeConfig) : <Outlet />)}
        </ExperimentsContent>
      </ExperimentsReadyGate>
    </ExperimentsProvider>
  );
}

ExperimentsWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  flowConfig: PropTypes.shape({
    id: PropTypes.string.isRequired,
    entityType: PropTypes.string
  })
};

export default ExperimentsWrapper;
